var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sys-select-base',{attrs:{"model":_vm.selected,"items":_vm.items,"loading":_vm.loading,"label":_vm.label,"error":_vm.error,"errors":_vm.errors,"showAdd":_vm.showAdd,"clearable":_vm.clearable,"dense":_vm.dense},on:{"update:model":function($event){_vm.selected=$event},"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }